module.exports = __webpack_public_path__ + "media/loader_mob_def.fd206841.ogg";